<template>
  <el-dialog class="user_model_dialog" top="5vh" center :title="newTitle" :append-to-body="true" width="70%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <div style="display: flex;">
        <el-form-item  label="团队名称" prop="name" :label-width="formLabelWidth" style="width:50%;">
          <el-input v-model="form.name" autocomplete="off" :disabled="!isEdit"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width:30%;">
          <el-switch v-model="form.status" :disabled="!isEditOrCreate" active-color="#11a983" inactive-color="#f5f7fa" active-value="1" inactive-value="0">
          </el-switch>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item  label="负责人" prop="ownerId" :label-width="formLabelWidth" style="width:50%;">
          <el-select  filterable collapse-tags size="mini" v-model="form.ownerId" :disabled="!isEdit"  placeholder="请选择负责人">
            <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.id" label="创建时间" prop="createTime" :label-width="formLabelWidth" style="width:40%;">
          <el-input v-model="form.create_time"  :disabled="true" autocomplete="off">
          </el-input>
        </el-form-item>
      </div>
      <el-form-item label="成员" prop="teamMates" :label-width="formLabelWidth" label-position="left">
        <el-select  filterable  clearable multiple size="mini" v-model="form.teamMates"  placeholder="请选择人员" :disabled="!isEdit"  style="width: 80%">
          <el-option v-for="(key, value) in allUser" :key="key" :label="key" :value="value" />
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remarks" :label-width="formLabelWidth" style="width:80%;">
        <el-input type="textarea" rows="3" v-model="form.remark" autocomplete="off" placeholder="备注" :disabled="!isEdit"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="isEdit" :loading="loading.submit" type="primary"  @click="onSubmit">保存</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formatEnToUtf8, formatTimeToDate } from "@/views/tops/devOps/components/util.js";
import {
  getDevOpsSpaceTeamDetaililApi,
  getDevOpsSpaceUserDetailApi,
  getDevOpsSpaceUserRoleListApi,
  postDevOpsSpaceAddTeamApi,
  postDevOpsSpaceCreateDemandApi,
  postDevOpsSpaceEditDemandApi, postDevOpsSpaceUpdateTeamApi,
  postDevOpsSpaceUpdateUserApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
export default {
  components: {},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    isEdit:{
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        status: '1',
        ownerId: '',
        teamMates: [],
      },
      rules: {
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        status: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        ownerId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        teamMates: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
      },
      allRoles: [],
      allUser:[],
    };
  },
  async mounted() {
    const { id = ''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const userId = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';

    this.form = { ...this.form, id}
    this.$set(this.form, 'username', username)
    this.username = username;
    this.$nextTick(async () => {
      await this.getDevOpsSpaceAllUser();
      if(id) await this.init(id)
      if(!id && userId ){
        this.form.ownerId = userId.toString()
        this.form.teamMates = [userId.toString()]
      }



    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
        }
    ),
    // 部分不可编辑
    isProjectDisabled() {
      return true;
    },
    newTitle() {
      if (this.form.id) {
        return '编辑团队';
      } else {
        return '创建团队'
      }
    },
    isEditOrCreate(){
      if(!this.form.id){
        return false;
      }
      if(this.isEdit){
        return this.isEdit;
      }

      return false;
    },
  },
  methods: {
    getDate() {
      var now = new Date().getTime();
      return now;
    },
    changeSwitch(v){
      console.log(v);
    },
    async getDevOpsSpaceAllUser(){
      const ret = await getDevOpsSpaceAllUserListApi();
      let arr = {};
      if(ret.status === 'success'){
        ret.data.forEach((item,index)=>{
          if(item.user_type !== 1 && item.user_type !== 13){
            arr[item.id] = item.user_name;
          }
        });
      }
      this.allUser = arr;
    },
    // 获取详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceTeamDetaililApi({ id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          status: info.status.toString(),
          teamMates: info.teamMates ? info.teamMates.split(',') : [],
          ownerId: info.owner_id ? info.owner_id.toString() : '',
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    // 提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    async moduleSubmit(close = true){
      try {
        close && this.$set(this.loading, 'submit', true)
        const {
          name = "",
          ownerId = "",
          teamMates = [],
          remark = '',
          status = '',
          id = '',
        } = this.form;
        const param = { name, ownerId: Number(ownerId),teamMates:teamMates.toString(), remark, status ,id};
        // id 存在 更新 不存在 创建
        const ret = this.form.id ? await postDevOpsSpaceUpdateTeamApi({ ...param, id: this.form.id || "" }) : await postDevOpsSpaceAddTeamApi(param);
        if (ret.status === 'success') {
            this.$notify({
              message: ret.message || '提交成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()

            }, 500)
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
    formatTimeToDate,
  }
};
</script>
<style lang="scss">
.user_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-form-item__content {
    line-height: 16px;
  }
  .el-form-item__label {
    font-weight: bold;
    font-size: 12px;
  }
}

.popperDom {
  max-width: 240px;
}
</style>
